<template>
  <div
    v-if="stepCount > 0"
    :class="$style.onboaring__progress"
  >
    <div
      v-for="stepNumber of stepCount"
      :key="`step-${stepNumber}`"
      :class="stepClass(stepNumber)"
    />
  </div>
</template>

<script setup lang="ts">
const $style = useCssModule();

const { step } = defineProps<{
  stepCount: number;
  step: number | null;
}>();

const stepClass = (stepNumber: number) => [
  $style.onboaring__progress__step,
  {
    [`${$style['onboaring__progress__step--done']}`]: step !== null && step >= stepNumber,
  },
];
</script>

<style lang="postcss" module scoped>
.onboaring__progress {
  display: flex;
  gap: var(--space-100);
  width: 100%;

  &__step {
    height: 6px;
    border: 1px solid var(--color-mono-600);
    border-radius: var(--border-radius-100);
    flex-grow: 1;
    position: relative;
    overflow: hidden;
    transition: background-color 0.6s ease-in-out;

    &--done {
      background-color: var(--color-mono-600);
    }
  }
}
</style>
